<div
  chkRtl
  leaflet
  class="map-leaflet"
  [leafletOptions]="options"
  (leafletMapReady)="onMapReady($event)"
  (leafletClick)="onMapClick($event)"
  (dblclick)="onDoubleClick($event)"
></div>
